<template>
  <section
    id="batchingID"
    class="case-creation"
    v-loading="loading"
    element-loading-text="Loading..."
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <div class="container-default">
      <div class="case-creation__step case-creation__patient-information">
        <div class="case-creation__card">
          <div class="case-creation__body pb-0">
            <div class="vue-form">
              <el-form :model="form">
                <el-row :gutter="30">
                  <el-col :span="4">
                    <div class="case-creation__input">
                      <el-form-item>
                        <label for="text">
                          Title
                          <span class="star">*</span>
                        </label>
                        <el-input
                          placeholder="Enter title"
                          v-model="form.title"
                        >
                        </el-input>
                        <p class="err" v-if="getErrors && getErrors.title">
                          <FormError errorName="title"></FormError>
                        </p>
                      </el-form-item>
                    </div>
                  </el-col>
                  <el-col :span="4">
                    <div class="case-creation__input">
                      <el-form-item>
                        <label for="text"> Select a Panel </label>

                        <el-select
                          v-model="case_type"
                          placeholder="Select Case Type"
                          :disabled="isEdit"
                          @change="handleCaseTypeChange"
                        >
                          <el-option
                            v-for="item in getCaseTypes"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          >
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </div>
                  </el-col>
                </el-row>
              </el-form>
              <p class="err" v-if="getErrors && getErrors.critical_error">
                <FormError errorName="critical_error"></FormError>
              </p>
            </div>
          </div>
        </div>
        <div v-if="hasCaseType">
          <AddCaseForReport
            :caseType="case_type"
            :accessionData="form.accession_data"
            @saveAccessionData="updateAccessionData"
            @closeDialog="dialogSelectCase = false"
          ></AddCaseForReport>
        </div>
        <div class="case-creation__actions fixed" v-if="hasCaseType">
          <ul class="list">
            <li>
              <el-button
                type="button"
                class="btn cancel-button"
                @click="goToReportsList"
                >CANCEL</el-button
              >
            </li>
            <li>
              <el-button
                type="button"
                class="btn save-button"
                @click="updateReportData"
                v-if="this.$route.params.id"
                >UPDATE</el-button
              >
              <el-button
                type="button"
                class="btn save-button"
                @click="saveReportData"
                v-else
                >SAVE</el-button
              >
            </li>
          </ul>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { defineAsyncComponent } from "vue";
import { mapGetters } from "vuex";
import AddCaseForReport from "./AddCasesForReport";
import caseConstants from "@/config/constants/caseConstants";
const FormError = defineAsyncComponent(() =>
  import("@/components/misc/FormError")
);
import {
  successNotification,
  errorNotification,
} from "@/helpers/notifications";
export default {
  name: "CardiacCaseGrouping",
  components: {
    AddCaseForReport,
    FormError,
  },
  data() {
    return {
      loading: false,
      caseTypes: caseConstants.CASE_TYPES_DATA,
      dialogSelectCase: false,
      case_type: "",
      form: {
        title: "",
        case_type: "",
        status: "ACTIVE",
        sent_status: false,
        report_data: "",
        accession_data: [],
      },
    };
  },
  computed: {
    getCaseTypes() {
      return this.caseTypes.filter(
        (caseType) => caseType.report_selection == true
      );
    },

    hasCaseType() {
      return this.form.case_type ? true : false;
    },
    isEdit() {
      return this.$route.params.id ? true : false;
    },
    ...mapGetters("reportFiles", [
      "getReportFileById",
      "getReportCreateStatus",
      "getReportUpdateStatus",
    ]),
    ...mapGetters("errors", ["getErrors", "getError"]),
  },
  async mounted() {
    this.$store.commit("errors/clear");
    if (this.$route.params.id) {
      this.loading = true;
      await this.$store.dispatch("reportFiles/show", this.$route.params.id);
      this.setFormData();
      this.loading = false;
    }
  },

  methods: {
    handleCaseTypeChange() {
      if (this.form.case_type && this.form.accession_data.length) {
        this.$confirm(
          "Are you sure to change case type? Existing case data was removed"
        )
          .then(() => {
            this.form.case_type = this.case_type;
            this.form.accession_data = [];
          })
          .catch(() => (this.case_type = this.form.case_type));
      } else {
        this.form.case_type = this.case_type;
      }
    },
    setFormData() {
      this.form = { ...this.getReportFileById };
      this.case_type = this.form.case_type;
    },

    async saveReportData() {
      if (this.checkAccessionData()) {
        this.loading = true;
        await this.$store.dispatch("reportFiles/create", this.form);
        this.loading = false;
        if (this.getReportCreateStatus) {
          successNotification("Report File created successfully");
          this.goToReportsList();
        } else if (!this.getErrors) {
          errorNotification("Error in creating Report FIle");
        }
      }
    },
    async updateReportData() {
      if (this.checkAccessionData()) {
        this.loading = true;
        let params = {
          id: this.$route.params.id,
          params: this.form,
        };
        await this.$store.dispatch("reportFiles/update", params);
        this.loading = false;
        if (this.getReportUpdateStatus) {
          successNotification("Report File updated successfully");
          this.goToReportsList();
        } else if (!this.getErrors) {
          errorNotification("Error in updating Report FIle");
        }
      }
    },
    goToReportsList() {
      if (
        this.$route.params &&
        this.$route.params.id &&
        this.$route.query &&
        this.$route.query.redirectRoute
      ) {
        let query = this.$route.query;
        let redirectRoute = this.$route.query.redirectRoute;
        delete query.redirectRoute;
        this.$router.push({
          name: redirectRoute,
          query: query,
        });
      } else if (this.$route.query && this.$route.query.redirectRoute) {
        let query = this.$route.query;
        let redirectRoute = this.$route.query.redirectRoute;
        delete query.redirectRoute;
        this.$router.push({
          name: redirectRoute,
          query: query,
        });
      } else {
        this.$router.push({
          name: "ReportsList",
          query: { ...this.$route.query, redirectRoute: this.$route.name },
        });
      }
    },
    updateAccessionData(data) {
      this.form.accession_data = data;
      this.dialogSelectCase = false;
    },
    checkAccessionData() {
      if (this.form.accession_data && this.form.accession_data.length)
        return true;
      this.$message.warning("Please select cases");
      return false;
    },
  },
  filters: {
    getPatientName(val) {
      return val;
    },
  },
};
</script>

<style lang="scss">
#batchingID {
  .el-scrollbar {
    .el-scrollbar__wrap {
      max-width: 100%;
      overflow-x: scroll;
    }
  }
}
</style>
